import {
  GET_REQUEST_CLIENTS,
  GET_REQUEST_CLIENTS_SUCCESS,
  GET_REQUEST_CLIENTS_FAILURE,
  CREATE_ONEAPP_CLIENT_REQUEST,
  CREATE_ONEAPP_CLIENT_SUCCESS,
  CREATE_ONEAPP_CLIENT_FAILURE,
  CREDIT_REGISTER_SUCCESS,
  CREDIT_REGISTER_FAILED,
  RESET_ERROR,
} from "../../actions/actionTypes";

const initialState = {
  requestClients: [],
  isOneAppClientCreated: false,
  loading: false,
  error: null,
  creditRegister: {}
};

export const clientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUEST_CLIENTS:
      return {
        ...state,
        error: null,
      };
    case GET_REQUEST_CLIENTS_SUCCESS:
      return {
        ...state,
        requestClients: action.payload.map((el) => ({
          value: el.id,
          label: el.fullName,
        })),
      };
    case GET_REQUEST_CLIENTS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_ONEAPP_CLIENT_REQUEST:
      return {
        ...state,
        isOneAppClientCreated: false,
        loading: true,
        error: null,
      };
    case CREATE_ONEAPP_CLIENT_SUCCESS:
      return {
        ...state,
        isOneAppClientCreated: true,
        loading: false,
      };
      case CREDIT_REGISTER_SUCCESS:
      return {
        ...state,
        creditRegister: action.payload,
        error: null,
      };
      case CREDIT_REGISTER_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_ONEAPP_CLIENT_FAILURE:
      return {
        ...state,
        isOneAppClientCreated: false,
        loading: false,
        error: action.payload,
      };
      case RESET_ERROR:
      return {
        ...state,
        isOneAppClientCreated: false,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
